<template>
  <div :class="className" :style="slickStyle">
    <template v-for="item in copyList">
      <slot name="slickItem" :item="item" :itemStyle="itemStyle"></slot>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    className: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    pos: {
      type: Number,
      default: 0
    },
    animateMode: {
      type: String,
      default: 'speed'
    },
    time: {
      type: Number,
      default: 10000
    },
    speed: {
      type: Number,
      default: 0.8
    },
    slidesToShow: {
      type: Number,
      default: 3
    },
    absolute: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      windowWidth: 0,
      listX: 0
    };
  },
  computed: {
    itemWidth() {
      return Math.floor(this.windowWidth / this.slidesToShow);
    },
    itemStyle() {
      return { width: `${this.itemWidth}px` };
    },
    copyList() {
      const list = this.list.concat(this.list);
      return list;
    },
    slickStyle() {
      // 根据是否浮动，有不同的计算
      let x =
        this.pos === -1
          ? this.windowWidth -
            2 * this.list.length * this.itemWidth +
            this.listX
          : this.listX;
      if (!this.absolute) {
        x =
          this.pos === -1
            ? this.listX
            : 2 * this.list.length * this.itemWidth -
              this.windowWidth +
              this.listX;
      }
      return {
        width: `${2 * this.list.length * this.itemWidth}px`,
        transform: `translateX(${x}px)`
      };
    }
  },
  watch: {
    itemStyle() {
      setTimeout(() => {
        this.$emit('resetStyle');
      }, 300);
    }
  },
  mounted() {
    window.iii = setInterval(() => {
      const listWidth = this.list.length * this.itemWidth;
      if (this.pos === -1) {
        // 向右
        if (this.listX > listWidth) {
          this.listX = 0;
        } else {
          if (this.animateMode === 'speed') {
            this.listX += this.speed;
          }
          if (this.animateMode === 'time') {
            this.listX += listWidth / this.time;
          }
        }
      } else {
        // 向左
        if (this.listX * -1 > listWidth) {
          this.listX = 0;
        } else {
          if (this.animateMode === 'speed') {
            this.listX -= this.speed;
          }
          if (this.animateMode === 'time') {
            this.listX -= listWidth / this.time;
          }
        }
      }
    }, 10);
    window.addEventListener('resize', () => {
      this.getWindowWidth();
    });
    this.getWindowWidth();
  },
  methods: {
    getWindowWidth() {
      this.windowWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
    }
  }
};
</script>

<style></style>
